export default "__VITE_ASSET__RjpIgWfI__"